import React from "react";
import Avatar from "@mui/material/Avatar";
import "./Card.css";
import CurrencyRupeeRoundedIcon from "@mui/icons-material/CurrencyRupeeRounded";
export default function BasicCard({ state, onClick }) {
  React.useEffect(() => {
    if (state) {
        document.getElementById("basicCard").classList.add("activateCard");
    } else {
        document.getElementById("basicCard").classList.remove("activateCard");
    }
    return () => {
    };
  }, [state]);
  return (
    <div className="" onClick={onClick}>
      <div id="basicCard" className="card col-md-12 col-12 ms-md-1">
        <div className="d-flex aligns-items-center justify-content-center">
          <Avatar sx={{ bgcolor: "blue" }}>
            <CurrencyRupeeRoundedIcon />
          </Avatar>
        </div>
        <p className="membership-type d-flex aligns-items-center justify-content-center">
          Basic
        </p>
        <div className="d-flex aligns-items-center justify-content-center">
          <i>100</i>
        </div>
      </div>
    </div>
  );
}
